<template>
  <div class="error">
    <h1>Доступ запрещен</h1>
  </div>
</template>

<script>
export default {
  name: 'AccessDenied'
}
</script>

<style lang="scss" scoped>
.error {
  h1 {
    font-size: 20px;
    text-align: center;
    padding: 42px 36px;
  }
}
</style>
